import { useState, useEffect } from 'react';

const DEFAULT_FONT_SIZE = 16; // Base font size in pixels
const STEP_SIZE = 2; // How much to increase/decrease by
const MIN_SIZE = 12;
const MAX_SIZE = 24;

export const useFontSize = () => {
  const [fontSize, setFontSize] = useState(() => {
    const saved = localStorage.getItem('fontSize');
    return saved ? parseInt(saved) : DEFAULT_FONT_SIZE;
  });

  useEffect(() => {
    localStorage.setItem('fontSize', fontSize.toString());
    document.documentElement.style.setProperty('--base-font-size', `${fontSize}px`);
  }, [fontSize]);

  const increaseFontSize = () => {
    setFontSize(prev => Math.min(prev + STEP_SIZE, MAX_SIZE));
  };

  const decreaseFontSize = () => {
    setFontSize(prev => Math.max(prev - STEP_SIZE, MIN_SIZE));
  };

  const resetFontSize = () => {
    setFontSize(DEFAULT_FONT_SIZE);
  };

  return {
    fontSize,
    increaseFontSize,
    decreaseFontSize,
    resetFontSize
  };
}; 